import { apiService } from "../../app.service";

export const teamApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch all team members (with optional location filter)
    fetchTeamMembers: builder.query({
      query: (locationId) => ({
        url: `/member${locationId ? `?locationId=${locationId}` : ''}`,
      }),
      providesTags: ["member"],
    }),

    // ✅ Fetch a single team member
    fetchTeamMember: builder.query({
      query: (id) => ({
        url: `/member/${id}`,
      }),
      providesTags: (result, error, id) =>
        result ? [{ type: "member", id }] : [],
    }),

    // ✅ Create a new team member (invite)
    createTeamMember: builder.mutation({
      query: (data) => ({
        url: "/member",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["member"],
    }),

    // ✅ Update an existing team member
    updateTeamMember: builder.mutation({
      query: ({ id, data }) => ({
        url: `/member/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "member", id },
        "member",
      ],
    }),

    // ✅ Delete a team member
    deleteTeamMember: builder.mutation({
      query: (id) => ({
        url: `/member/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["members"],
    }),

    // ✅ Resend invitation
    resendInvitation: builder.mutation({
      query: (memberId) => ({
        url: `/member/resend-invitation/${memberId}`,
        method: "POST",
      }),
      invalidatesTags: ["member"],
    }),

    // ✅ Set member password (for invitation)
    setMemberPassword: builder.mutation({
      query: (data) => ({
        url: "/member/set-password",
        method: "POST",
        body: data,
      }),
    }),

    // ✅ Verify invitation token
    verifyInvitationToken: builder.mutation({
      query: (data) => ({
        url: "/member/verify-token",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useFetchTeamMembersQuery,
  useFetchTeamMemberQuery,
  useCreateTeamMemberMutation,
  useUpdateTeamMemberMutation,
  useDeleteTeamMemberMutation,
  useResendInvitationMutation,
  useSetMemberPasswordMutation,
  useVerifyInvitationTokenMutation,
} = teamApi;